import * as React from 'react';

// Types
import { IUser } from '../types';

type AuthProviderProps = {
    children?: React.ReactNode;
};

export interface IAuthState extends Partial<IUser> {
    initializing: boolean;
}

export interface IAuthContext {
    authState?: IAuthState;
    firebaseState?: IFirebaseContext;
    setFirebaseState?: React.Dispatch<React.SetStateAction<IFirebaseContext>>;
    setAuthState?: React.Dispatch<React.SetStateAction<IAuthState>>;
}

interface IFirebaseContext {
    initializing: boolean;
    user?: any;
    versions?: {
        client?: string;
    };
}

export const defaultFirebaseAuthState = {
    initializing: true,
    user: false,
    versions: {
        client: import.meta.env.VITE_PACKAGE_VERSION ?? ''
    }
};
export const defaultAuthState = {
    initializing: true,
    email: undefined,
    _id: undefined,
    clientId: undefined,
    name: undefined,
    hasSignedAgreement: false
};

export const AuthContext: React.Context<IAuthContext> = React.createContext({} as IAuthContext);

export const AuthProvider: React.FC<AuthProviderProps> = ({ children, ...props }) => {
    const [firebaseState, setFirebaseState] = React.useState<IFirebaseContext>(defaultFirebaseAuthState);
    const [authState, setAuthState] = React.useState<IAuthState>(defaultAuthState);

    return (
        <AuthContext.Provider value={{ authState, firebaseState, setFirebaseState, setAuthState }}>
            {children}
        </AuthContext.Provider>
    );
};
